import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { get } from '#utilities/js/ea/ajax.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault,
    stopImmediatePropagation
  ]),
  task: async (
    button
  ) => {
    const { ariaExpanded } = button
    const newAriaExpanded = ariaExpanded === 'false'
    await syncExpandedState(button)
    button.setAttribute('aria-expanded', newAriaExpanded)
  }
})

export const syncExpandedState = async item => {
  const { ownerDocument, ariaExpanded } = item
  const newAriaExpanded = ariaExpanded === 'false'
  const scopeJson = scope(item)

  if (scopeJson) {
    const { update_expand_status_request_url, auto_collapse_expandables = false } = scopeJson

    if (newAriaExpanded && auto_collapse_expandables) {
      const nav = closest('nav', item)
      all(`[data-contract~="nav.expanded"][aria-expanded="true"]`, nav).forEach(e => e.click())
    }

    if (update_expand_status_request_url) {
      const { defaultView, location } = ownerDocument
      const { URL } = defaultView
      const expandRequest = new URL(update_expand_status_request_url, location)
      expandRequest.searchParams.append('expand', newAriaExpanded.toString())
      await get(expandRequest, { target: item })
    }
  }
}

export default button => {
  onClick.listen(button)
}
